import React, {useEffect, useRef} from "react";
import gsap from "gsap";
import Button from "../Global/Button";
import Link from "../Pictos/Link";
import styles from "./ArticleLink.module.scss";
import Image from "../Global/Image";
import isMobile from "ismobilejs";

export default function ArticleLink({title, href, image, mobile, position = 'center', classname}) {
    const article = useRef(null);

    useEffect(() => {
        if (!isMobile().phone || window.outerWidth > 800) {
            window.addEventListener('scroll', () => {
                const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

                const articleRect = article.current.getBoundingClientRect();
                const articleBottom = vh - articleRect.bottom;

                if (articleRect.top < vh && articleRect.bottom > 0) {
                    gsap.set(article.current, {
                        x: position === 'right' ? -(articleBottom * .1) : articleBottom * .1
                    })
                }

            }, {passive: true})
        }
    }, [position]);

    return (
        <article className={[styles.Main, position, classname].join(' ')} ref={article}>
            <Image {...image} mobile={mobile}
                   classname={styles.Background}/>

            <div className={styles.MastheadText}>
                <h2>
                    {title}
                </h2>
                <Button text={"Lire l'article"} url={href} target={'_blank'}>
                    <Link/>
                </Button>
            </div>
        </article>
    )
}
